export default __webpack_public_path__ + "static/media/boiteIntro.7eb36ad7.png";